import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, throttleTime } from 'rxjs/operators';
import { requestActions } from './apiHelpers';
import { ID, ReduxAction } from '../types';
import { activityApiObservable } from '@support/api';

/* Epic actions */
const highlightsActions = requestActions('HIGHLIGHTS', ['fetch']);

/* Component actions */
export const fetchHighlights = (contactID: ID) => ({
  type: 'FETCH_HIGHLIGHTS',
  payload: { contactID },
});

/* Epics */
export const fetchHighlightsEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_HIGHLIGHTS'),
    groupBy(({ payload }) => payload.contactID),
    mergeMap((fetchesByID) =>
      fetchesByID.pipe(
        // For a given contact, only fetch the highlights at most once every 1 minute
        throttleTime(1000 * 60 * 1),
        mergeMap(({ payload }) =>
          activityApiObservable('GET', `activity/contacts/${payload.contactID}/highlights/`).pipe(
            map((response) => {
              return highlightsActions['fetchSucceeded']({
                ...response,
                contactID: payload.contactID,
              });
            }),
            catchError((err) => of(highlightsActions['fetchFailed'](err))),
          ),
        ),
      ),
    ),
  );

export const highlightsEpic = combineEpics(fetchHighlightsEpic);
